import React, { useState, useRef, useEffect } from "react";
import { MoreHorizontal } from "lucide-react";

export type MenuItem = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  showDivider?: boolean;
};

interface PopoverMenuProps {
  items: MenuItem[];
}

const PopoverMenu: React.FC<PopoverMenuProps> = ({ items }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={ref}>
      <button onClick={() => setOpen((prev) => !prev)} className="p-2">
        <MoreHorizontal className="text-pink-600" />
      </button>

      {open && (
        <div className="absolute right-5 top-4 mt-2 w-44 origin-top-right rounded-md shadow-md bg-white ring-1 ring-black/5 z-50">
          <div className="py-1 text-xs">
            {items.map((item, index) => (
              <React.Fragment key={index}>
                <button
                  className="flex items-center w-full px-4 py-2 text-left text-gray-700 hover:bg-pink-50 hover:text-pink-600 transition"
                  onClick={() => {
                    setOpen(false);
                    item.onClick();
                  }}
                >
                  <span className="mr-2 text-pink-600">{item.icon}</span>
                  {item.label}
                </button>
                {item.showDivider && (
                  <div className="border-t border-pink-200 my-1" />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PopoverMenu;
